import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import bookdetails from '../Assets/pilates down.jpeg'

function Service1() {
  return (
   <>
    <Navbar/>
    <div className='aboutbanner aboutbanner11'>
    <h3>Pilates  </h3>
    {/* <p>Escape, Recharge & Renew</p> */}

    </div>
    <div className='about-classes'>
    <div className='about-classes-left'>


    <p>A powerful way to build strength, improve flexibility, and enhance posture through controlled movements and mindful breathing.</p>
    
   <br/>

    <h3>Reformer Pilates</h3>
    
    <ul>
        <li><b>Beginner </b>– Start your Pilates journey with confidence in our beginner-friendly class designed to build strength, improve posture, and enhance flexibility. This session focuses on mastering core fundamentals — from controlled movements to proper breathing techniques — helping you develop body awareness and stability. With personalized guidance and gentle progressions, you'll gain the skills and confidence to move with strength, precision, and ease. Perfect for newcomers or those looking to refine their foundation.</li>
       
        <li><b>Intermediate  </b>– For those looking to deepen their practice and improve technique.</li>
        <li><b>Advanced </b>– A challenging session designed to enhance strength and flexibility.</li>
        <li><b>Pre-Natal  </b>– Gentle yet effective movements tailored for expecting mothers.
(<i>Available in mixed classes and ladies-only sessions</i>)
</li>
      
       


    </ul>

    <br/>
    <h3>Mat Pilates</h3>

    <p>Strengthen your core, improve posture, and build endurance through focused mat exercises.
<i>(Available in mixed classes and ladies-only sessions)</i>
</p>
    

    
</div>
   <div className='about-classes-right'>
<img src={bookdetails}/>
 

</div>
    </div>
    <Footer/>
   </>
  )
}

export default Service1